/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
/** @jsxImportSource solid-js */

import { customElement } from 'solid-element';
import { ICustomElement, noShadowDOM } from 'component-register';
import RestrictedAccessSplashScreen, {
  RestrictedAccessSplashScreenProps,
  ButtonType,
} from './RestrictedAccessSplashScreen';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-restricted-access-splash-screen': Partial<HTMLElement> &
        RestrictedAccessSplashScreenProps &
        Partial<{ ref: ICustomElement }>;
    }
  }
}

export function defineSolidRestrictedAccessSplashScreen(): void {
  customElement(
    'tc-restricted-access-splash-screen',
    {
      // Include ALL component properties with default values here
      // This is CRITICAL for proper property synchronization
      title: undefined,
      subHeading: undefined,
      description: undefined,
      showIcon: false,
      linkText: undefined,
      linkUrl: undefined,
      buttonLabel: undefined,
      showBackgroundImage: false,
      buttonType: 'primary',
      onButtonClick: undefined,
      onLinkClick: undefined,
      isLoading: false,
      content: undefined,
    },
    (props, { element }) => {
      // Call noShadowDOM in wrapper, not component
      noShadowDOM();

      // Handle event bridging
      function handleButtonClick(): void {
        const evt = new CustomEvent('splash-screen-button-click', {
          detail: {
            buttonType: props.buttonType,
            buttonLabel: props.buttonLabel,
          },
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function handleLinkClick(): void {
        const evt = new CustomEvent('splash-screen-link-click', {
          detail: {
            linkText: props.linkText,
            linkUrl: props.linkUrl,
          },
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      return (
        <RestrictedAccessSplashScreen
          title={props.title}
          subHeading={props.subHeading}
          description={props.description}
          showIcon={props.showIcon}
          linkText={props.linkText}
          linkUrl={props.linkUrl}
          buttonLabel={props.buttonLabel}
          showBackgroundImage={props.showBackgroundImage}
          buttonType={props.buttonType as ButtonType}
          isLoading={props.isLoading}
          content={props.content}
          onButtonClick={handleButtonClick}
          onLinkClick={handleLinkClick}
        />
      );
    }
  );
}
